import { render, staticRenderFns } from "./Pembayaran.vue?vue&type=template&id=8fcaf534&scoped=true&"
import script from "./Pembayaran.vue?vue&type=script&lang=js&"
export * from "./Pembayaran.vue?vue&type=script&lang=js&"
import style0 from "./Pembayaran.vue?vue&type=style&index=0&id=8fcaf534&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcaf534",
  null
  
)

export default component.exports